module.exports = __webpack_public_path__ + "1538eb4ce01662220f4d0b6eab121a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/ireland_icon.png
// module id = 1224
// module chunks = 0